import { Link } from "@tanstack/react-router";
import { AuthShell } from "../../components/auth/AuthShell";

/**
 * AUTH-02 — AMSaaS (B2B) **provider** login: https://amsaas.app/login/provider.
 *
 * Door for the provider console (catalogue, clients, billing, team). Provider
 * identities are valid on both apps and land in the same host-agnostic console
 * regardless of the door used (AUTH-10, TOP-07). No org switcher for providers
 * (OS-02). Neutral, app-branded only (WL-03).
 */
export function AmsaasProviderLoginPage(): JSX.Element {
  return (
    <AuthShell
      appName="AMSaaS"
      appTagline="Application Management Services as a Service"
      logoSrc="/logos/amsaas-login-banner.png"
      logoSrc2x="/logos/amsaas-login-banner@2x.png"
      accent="#0ea5e9"
      panelClassName="bg-gradient-to-br from-slate-950 via-slate-900 to-cyan-950"
      audienceLabel="Provider sign-in"
      headline="Run your service business on autopilot. Every client. Every service. One view."
      blurb="Sign in to manage application managed services, subscriptions, and billing for every client — all in one place, all self-service."
      quote={{
        text: "We launched our service catalogue and billed our first clients within a week.",
        author: "Marcus Lee, Founder, NorthBridge IT",
      }}
      footer={
        <p>
          Are you a client?{" "}
          <Link
            to="/login/client"
            className="font-medium text-foreground hover:underline"
          >
            Client sign-in
          </Link>
        </p>
      }
    />
  );
}
